import React, { useEffect, useState } from "react";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import OrganizationMemberService from "./OrganizationMemberService";
import { useHistory } from "react-router-dom";
import Cs from "../../../services/CommonService";
import { useSubscriptionAccess } from '../../Subscriptions/useSubscription';

const useMemberCaseAlertHook = () => {
  const {currentUser} = useCurrentUserHook();
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [caseAlerts, setCaseAlerts] = useState([]);

  const {subscriptionAccesses} = useSubscriptionAccess();

  const getMemberReport = async (req) =>{
    const {status, data} = await OrganizationMemberService.getOrgMemberAlerts(req);
    setCaseAlerts(data.case_alerts);
    setLoading(false);
  }

  return {
    currentUser,
    history,
    loading, setLoading,
    caseAlerts, setCaseAlerts,
    subscriptionAccesses,
    getMemberReport
  }
}

function MemberCaseAlerts({alertTypes, organizationId, userId}) {

  const { currentUser, history, loading, setLoading, caseAlerts, setCaseAlerts, subscriptionAccesses, getMemberReport } = useMemberCaseAlertHook();

  useEffect(()=>{
    getMemberReport({
      'organization_id': organizationId,
      'user_id': userId,
      'alert_types': alertTypes
    })
  }, [])
  
  const routeJourney = (alert) =>{
    //const mcjProcessForms = subscriptionAccesses.pins_process_mcj.options;
    history.push({
      'pathname':`/ecn/common/page/${alert.journey_profile_id}`,
      'search':`?type=infant_journey&case_alert_id=${alert.id}`
    })
  }

  return(
    <div className="table-icon-gray p-10 vh-80 scroll-auto">
      {caseAlerts.map((a, k)=>
        <div key={k} className="bg-white br-l-red-4 rounded-3 br-light p-15 m-b-10 cursor-pointer" onClick={() => routeJourney(a)}>
          <p className="fw500">{a.case_id} - {a.case_name}</p>
          <p>{a.alert_msg}</p>
          <div className="comma">Follow up Days - {a.no_activity_days?.map((d, k)=> <span key={k}>{d}</span>)}</div>
          <p className="text-right m-r-5 text-muted">{Cs.formatUpdateDate(a.created_at)}</p>
        </div>
      )}
    </div>
  )

}

function MemberCaseAlert({alertId}) {

  const { loading, setLoading, caseAlerts, setCaseAlerts, getMemberReport } = useMemberCaseAlertHook();

  useEffect(()=>{
    getMemberReport({'id': alertId});
  }, [])

  return(
    <div>
      {caseAlerts.map((a, k)=>
        <div key={k} className="bg-white br-l-red-4 rounded-3 br-light p-15 m-b-10 cursor-pointer">
          <p className="fw500 f18">{a.case_id} - {a.case_name}</p>
          <p className="f16 m-t-5">{a.alert_msg}</p>
          <div className="comma m-t-5">Follow up Days - {a.no_activity_days?.map((d, k)=> <span key={k}>{d}</span>)}</div>
          <p className="text-right m-r-5 text-muted">{Cs.formatUpdateDate(a.created_at)}</p>
        </div>
      )}
    </div>
  )

}

export {MemberCaseAlerts, MemberCaseAlert};